import React, { useEffect, useState } from 'react';
import { useAppContext } from '../context/AppContext';
import { Check } from 'lucide-react';
const steps = ['Analizando tu perfil profesional...', 'Evaluando tu situación actual...', 'Cruzando con 4,700+ Project Managers en LATAM...', 'Identificando herramientas IA para tu perfil...', 'Verificando elegibilidad Certificado Europeo...', 'Construyendo tu plan personalizado de 90 días...'];
export const Loading = () => {
  const {
    setCurrentPage
  } = useAppContext();
  const [progress, setProgress] = useState(0);
  const [activeStep, setActiveStep] = useState(0);
  const [isComplete, setIsComplete] = useState(false);
  useEffect(() => {
    const totalDuration = 6000; // 6 seconds total
    const intervalTime = 50;
    const stepsCount = totalDuration / intervalTime;
    let currentStep = 0;
    const timer = setInterval(() => {
      currentStep++;
      const newProgress = Math.min(100, currentStep / stepsCount * 100);
      setProgress(newProgress);
      const stepIndex = Math.min(5, Math.floor(newProgress / 100 * 6));
      setActiveStep(stepIndex);
      if (newProgress >= 100) {
        clearInterval(timer);
        setIsComplete(true);
        setTimeout(() => {
          setCurrentPage('results');
        }, 1000);
      }
    }, intervalTime);
    return () => clearInterval(timer);
  }, [setCurrentPage]);
  return <div className="min-h-screen bg-dark flex items-center justify-center text-white p-6" data-id="element-155">
      <div className="w-full max-w-[520px] text-center" data-id="element-156">
        <h2 className="text-[26px] font-bold mb-8" data-id="element-157">
          🤖 Analizando tus respuestas...
        </h2>

        <div className="bg-[#1E2A4A] rounded-full h-3 mb-4 overflow-hidden" data-id="element-158">
          <div className="h-full rounded-full bg-gradient-to-r from-primary to-gold transition-all duration-75 ease-linear" style={{
          width: `${progress}%`
        }} data-id="element-159" />
        </div>

        <div className="text-[52px] font-extrabold text-primary mb-7 leading-none" data-id="element-160">
          {Math.floor(progress)}%
        </div>

        <div className="text-left mb-6 space-y-2" data-id="element-161">
          {steps.map((step, idx) => {
          const isDone = activeStep > idx || isComplete;
          const isActive = activeStep === idx && !isComplete;
          const isPending = activeStep < idx;
          if (isPending) return null;
          return <div key={idx} className={`flex items-center gap-2.5 py-2 text-[14px] transition-colors duration-300
                  ${isDone ? 'text-success' : isActive ? 'text-white' : 'text-white/50'}`} data-id="element-162">
                <span className="w-6 text-center shrink-0" data-id="element-163">
                  {isDone ? <Check size={18} className="mx-auto" data-id="element-164" /> : '⏳'}
                </span>
                <span data-id="element-165">{step}</span>
              </div>;
        })}
        </div>

        {isComplete && <div className="text-success text-[22px] font-bold mt-4 animate-bounce" data-id="element-166">
            🎉 ¡Tu resultado está listo!
          </div>}

        <div className="text-[12px] opacity-35 mt-2" data-id="element-167">
          Por favor no cierres esta ventana
        </div>
      </div>
    </div>;
};